import { render, staticRenderFns } from "./ModulesTable.vue?vue&type=template&id=5c3f2d36&"
import script from "./ModulesTable.vue?vue&type=script&lang=js&"
export * from "./ModulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports